import { BrowserDetection } from '@inter-ikea-kompis/browser-support';

export default class SummaryPageBrowserUtility {
	public static isSafari14OrOlder(): boolean {
		const browser = BrowserDetection.getBrowser();
		if (browser?.name?.toLowerCase() !== 'safari') {
			return false;
		}

		const major = browser?.version?.split('.')?.[0];
		if (!major) {
			return false;
		}

		return parseInt(major) <= 14;
	}

	public static isSafari(): boolean {
		const browser = BrowserDetection.getBrowser();

		return browser?.name?.toLowerCase() === 'safari';
	}
}
